import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { ContentProvider } from "./context/ContentContext";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import Portfolio from "./pages/Portfolio";
import ProjectDetail from "./pages/ProjectDetail";
import OverMij from "./pages/OverMij";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import AlgemeneVoorwaarden from "./pages/AlgemeneVoorwaarden";
import Garantie from "./pages/Garantie";
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import AdminAanvragen from "./admin/AdminAanvragen";
import AdminProjecten from "./admin/AdminProjecten";
import AdminDiensten from "./admin/AdminDiensten";
import AdminTeksten from "./admin/AdminTeksten";
import AdminAccount from "./admin/AdminAccount";
import AdminVoorwaarden from "./admin/AdminVoorwaarden";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const SiteShell = () => (
  <div className="min-h-screen bg-white font-sans text-[#111111] antialiased">
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/diensten/:slug" element={<ServicePage />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/portfolio/:slug" element={<ProjectDetail />} />
      <Route path="/over-mij" element={<OverMij />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden />} />
      <Route path="/garantie" element={<Garantie />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    <Footer />
    <WhatsAppButton />
  </div>
);

const AppRoutes = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) {
    return (
      <Routes>
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="aanvragen" element={<AdminAanvragen />} />
          <Route path="projecten" element={<AdminProjecten />} />
          <Route path="diensten" element={<AdminDiensten />} />
          <Route path="teksten" element={<AdminTeksten />} />
          <Route path="voorwaarden" element={<AdminVoorwaarden />} />
          <Route path="account" element={<AdminAccount />} />
        </Route>
        <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
      </Routes>
    );
  }
  return <SiteShell />;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.12, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ContentProvider>
        <AuthProvider>
          <ScrollToTop />
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </ContentProvider>
    </BrowserRouter>
  );
}

export default App;
